import React, { useState, useEffect } from 'react';
import '../styles/CookiePopup.css';

function CookiePopup() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted/declined cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-popup">
      <div className="cookie-content">
        <button className="cookie-close" onClick={handleClose} aria-label="Close">
          ×
        </button>
        <h3 className="cookie-title">Cookie-uri și confidențialitate</h3>
        <p className="cookie-text">
          Folosim cookie-uri pentru a îmbunătăți experiența ta pe site-ul nostru și pentru a analiza traficul. 
          Acceptând, ești de acord cu utilizarea cookie-urilor conform politicii noastre de confidențialitate.
        </p>
        <div className="cookie-buttons">
          <button className="cookie-btn cookie-accept" onClick={handleAccept}>
            Accept
          </button>
          <button className="cookie-btn cookie-decline" onClick={handleDecline}>
            Refuz
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookiePopup;

